import * as React from "react";

import { AppContext } from "@1js/acui-context";
import {
  checkExperiment,
  ribbonExperiments,
  cspPolicyExperiments,
} from "@1js/acui-experiments";

export const useV9TooltipEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fluentV9TooltipIsEnabled
  );
};

export const useInnerHTMLPolicyEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    cspPolicyExperiments.isInnerHTMLPolicyEnabled
  );
};
